var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('mainSect'),_c('second'),_c('third'),_c('four'),_c('five'),_c('six'),_c('seven'),_c('eight')],1)}
var staticRenderFns = []

export { render, staticRenderFns }